import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';

import * as AuthAction from '../../../../store/auth/auth.actions';

import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthState } from '@app/store/auth/auth.state';
import { RoleEnum } from '@app/shared/enum/role.enum';
import { SetActiveRoute } from '@app/core/store/config/config.actions';
import { MatDialog } from '@angular/material/dialog';
import { EmailConfirmationComponent } from '../../components/email-confirmation/email-confirmation.component';
import { AuthService } from '@app/store/auth/auth.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass'],
})
export class LoginComponent implements OnInit {
  formLogin: FormGroup;
  showPassword: boolean;

  constructor(
    private _router: Router,
    private _store: Store,
    private _toastrService: ToastrService,
    private _fb: FormBuilder,
    private dialog: MatDialog,
    private _authService: AuthService
  ) {}

  private _subscribeLogin() {
    const auth: { roles: string[]; token: string } = this._store.selectSnapshot(AuthState);
    if (!environment.production) {
      this._authService.updateToken(auth.token);
    }
    this._handlePostLogin(auth);
  }

  private _handlePostLogin(auth: { roles: string[]; token: string }) {
    const systemRoles = Object.values(RoleEnum) as string[];
    const firstRoute = systemRoles.filter((r) => auth.roles.includes(r))[0];
    this._store.dispatch(new SetActiveRoute(firstRoute));
    this._router.navigate([firstRoute]);
  }

  private _errorLogin({ errors }: any) {
    const [message] = errors;
    this._toastrService.error(message);
  }

  private _buildForm() {
    this.formLogin = this._fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    this.checkCacheToken();
    this._buildForm();
  }

  onSubmit() {
    const { username, password } = this.formLogin.value;

    if (this.formLogin.valid) {
      this._store.dispatch(new AuthAction.AuthToken({ username, password })).subscribe({
        next: this._subscribeLogin.bind(this),
        error: this._errorLogin.bind(this),
      });
    } else {
      this._toastrService.error('Campo E-mail ou Senha inválidos.');
    }
  }

  forgetPass() {
    this.dialog.open(EmailConfirmationComponent, {
      maxWidth: '95%',
      minWidth: '43%',
    });
  }

  checkCacheToken() {
    const currentTime = new Date();

    const storedSessionExpires = sessionStorage.getItem('session_expires');
    if (!storedSessionExpires) {
      currentTime.setHours(currentTime.getHours() + 1);
      sessionStorage.setItem('session_expires', currentTime.getTime().toString());
    } else if (currentTime.getTime() >= parseInt(storedSessionExpires, 10)) {
      sessionStorage.clear();
      window.location.href = window.location.href;
    }
  }
}
